import { createRangeTagManager } from '../../utils/createRangeTagManager';

export const ceilingHeightTagManager = createRangeTagManager({
  jsonQueryKey: 'ceiling_height',
  template: 'Высота потолков %s м',
  id: 'ceilingHeight',
});
